import React, { useState, useEffect } from "react";
import {
  Input,
  Row,
  Typography,
  Card,
  Table,
  Spin,
  Select,
  Button,
  Tooltip,
} from "antd";
import { useNavigate, useLocation } from "react-router-dom";
import { BOM } from "../../../services/definedMethod";
import cnt from "../../../services/definedConstant";
import MainLayout from "../../../components/layouts/MainLayout";
import { connect, useDispatch } from "react-redux";
import { apiConfig, labelConfig, staticConfig } from "../teller.config";
import { rightAction } from "../../../redux/actions";
import TopContent from "../../../components/layouts/TopContent";
import { handleFlgStatus } from "../../../components/facilities/AccountFacility";

const { Text } = Typography;

const formatDate = (dateArr) => {
  if (!Array.isArray(dateArr) || dateArr.length < 3) return "—";
  const [y, m, d] = dateArr;
  return new Date(y, m - 1, d).toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "long",
    year: "numeric",
  });
};

const Teller = (props) => {
  const navigate = useNavigate();
  const { state: locationState } = useLocation();
  const { userData, rightBtn, rightAction } = props;
  console.log(locationState);

  const { session } = userData;

  const [tellerList, setTellerList] = useState([]);
  const [originalList, setOriginalList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [tableCount, setTableCount] = useState("10");
  const [selectedRow, setSelectedRow] = useState(null);

  const dispatch = useDispatch();

  const tillId = locationState?.id;

  useEffect(() => {
    dispatch({ type: cnt.CLEAR_RIGHT_BTN });
    rightAction(cnt.RIGHT_ADD_BTN);
    fetchTellers(tillId);
  }, []);

  const fetchTellers = (id) => {
    const url = `${apiConfig.Customizedteller}/${id}/tellers`;
    BOM.FetchReqAction({ session }, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors?.[0]?.defaultUserMessage || err);
        setIsLoading(false);
      } else {
        const mapped = (res || []).map((el) => ({
          key: el.id,
          id: el.id,
          tillProfileId: el.tellerProfile?.id,
          userName: el.appUser?.username ?? "—",
          tellerDescription: el.description ?? "—",
          status:
            el.status === "A"
              ? "Active"
              : el.status === "I"
                ? "Inactive"
                : (el.status ?? "—"),
          startDate: formatDate(el.startDate),
          endDate: formatDate(el.endDate),
        }));
        setTellerList(mapped);
        setOriginalList(mapped);
        setIsLoading(false);
      }
    });
  };

  const onSelectItemAction = (selectedRowKeys, objParam) => {
    //HOLD THE OBJECT SELECTED HERE
    setSelectedRow(objParam[0]);
    [
      BOM.HasPermission("READ_LINK_USER_TO_TILL") && cnt.RIGHT_DETAIL_BTN,
      BOM.HasPermission("UPDATE_LINK_USER_TO_TILL") && cnt.RIGHT_EDIT_BTN,
    ].map((item) => {
      dispatch({
        type: item,
      });
    });
  };

  const handleSearch = (e) => {
    const key = e.target.value?.toLowerCase();
    if (!key) {
      setTellerList(originalList);
      return;
    }
    setTellerList(
      originalList.filter(
        (item) =>
          item.userName?.toLowerCase().includes(key) ||
          item.tellerDescription?.toLowerCase().includes(key),
      ),
    );
  };

  function handleOnView() {
    const { detailBtn } = rightBtn;
    if (detailBtn.toLowerCase() === "primary") {
      navigate("/detail-teller", {
        state: {
          ...selectedRow,
          tillId,
        },
      });
    } else {
      console.log("Please choose a record from the table to open");
    }
  }

  function handleOnEdit() {
    const { editBtn } = rightBtn;
    if (editBtn.toLowerCase() === "primary") {
      navigate("/edit-teller", {
        state: {
          ...selectedRow,
          tillId,
        },
      });
    } else {
      console.log("Please choose a record from the table to edit");
    }
  }

  function handleOnCreate() {
    const { addBtn } = rightBtn;
    if (addBtn.toLowerCase() === "primary") {
      navigate("/new-teller", { state: locationState });
    } else {
      console.log("Could not open the link");
    }
  }

  const columns = [
    { title: "User Name", dataIndex: "userName", key: "userName" },
    {
      title: "Teller Description",
      dataIndex: "tellerDescription",
      key: "tellerDescription",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (v) => handleFlgStatus(v, {}, true),
    },
    { title: "Start Date", dataIndex: "startDate", key: "startDate" },
    { title: "End Date", dataIndex: "endDate", key: "endDate" },
  ];

  return (
    <MainLayout
      isEnableRightSidebar={true}
      onAdd={handleOnCreate}
      onView={handleOnView}
      onEdit={handleOnEdit}
    >
      <TopContent
        pageTitle={labelConfig.manageLinkUserToTillTeller}
        pageItems={staticConfig.manageLinkUserToTillTellerItems}
      />
      <Card
        style={{
          boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
          borderRadius: 20,
        }}
      >
        <Spin spinning={isLoading} size="large">
          <Row style={{ marginBottom: 20 }}>
            <div style={{ marginBottom: "auto" }}>
              <Text style={{ marginRight: 8 }}>Show</Text>
              <Select
                defaultValue={tableCount}
                options={[
                  { value: "5", label: "5" },
                  { value: "10", label: "10" },
                  { value: "25", label: "25" },
                  { value: "50", label: "50" },
                ]}
                onSelect={(v) => setTableCount(v)}
              />
              <Text style={{ marginLeft: 8 }}>Entries</Text>
            </div>
            <div style={{ margin: "0px 50px" }}>
              <Input
                onChange={handleSearch}
                placeholder="Filter by name / description..."
                style={{ width: 400 }}
                allowClear
              />
            </div>
          </Row>
          <Table
            rowSelection={{
              type: "radio",
              onChange: onSelectItemAction,
            }}
            columns={columns}
            dataSource={tellerList}
            bordered
            pagination={{
              position: ["bottomCenter"],
              pageSize: Number(tableCount),
            }}
          />
        </Spin>
      </Card>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = { rightAction };

export default connect(mapStateToProps, mapDispatchToProps)(Teller);
